<template>
  <v-col
    style="max-width: 150px;"
  >
    <v-card
      class="align-center mb-2"
    >
      <v-toolbar color="primary">
        <v-spacer />
        <v-btn
          read-only
          class="mt-1"
          :prepend-icon="icon"
          stacked
          readonly
          :text="title"
        />
        <v-spacer />
      </v-toolbar>
      <div class="text-headline-large text-center my-4">
        {{ value ?? 0 }}
      </div>
    </v-card>
  </v-col>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  title: string;
  value: string | number;
}>();
</script>
